<template>
  <ServiceListing />
</template>

<script>
  import ServiceListing from '@/views/ServiceListing.vue';
  export default {
    name: 'HomePage',

    components: {
      ServiceListing,
    },
  };
</script>
